import CryptoJS from 'crypto-js';
import { CIPHER_SECRET } from '../constants/constants';

export const signRequestPayload = (data: any) => {
  data.timestamp = Date.now();
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    CIPHER_SECRET
  ).toString();
  return ciphertext;
};

export const decryptData = (encodedCiphertext?: any) => {
  try {
    const ciphertext = decodeURIComponent(encodedCiphertext);
    const bytes = CryptoJS.AES.decrypt(ciphertext, CIPHER_SECRET);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    if (decryptedData?.timestamp) {
      const now: any = new Date();
      const previousTimestamp: any = new Date(decryptedData?.timestamp);
      const fiveMinutesInMillis = 5 * 60 * 1000;
      const difference = Math.abs(now - previousTimestamp);
      if (difference < fiveMinutesInMillis && decryptedData?.id) {
        return { data: decryptedData };
      } else if (decryptedData?.id) {
        return { error: 'Token Expired' };
      } else {
        return { error: 'Access Denied' };
      }
    }
    return { data: decryptedData };
  } catch (error) {
    return { error: 'Access Denied' };
  }
};
